import React from 'react';
import { ISubMenu } from './interfaces';
import { Collapse, List } from '@mui/material';
import { SubMenuItem } from './components/SubMenuItem';
import { useLocation } from 'react-router';

export const SubMenu: React.FC<ISubMenu> = ({
  show,
  menuOptions,
  onSubItemClick,
}): JSX.Element => {
  const location = useLocation();

  const isMenuOptionActive = (menuOptionLink: string): boolean => {
    if (menuOptionLink === '/' && location.pathname !== menuOptionLink) {
      return false;
    }

    return location.pathname.startsWith(menuOptionLink);
  };

  return (
    <Collapse in={show} timeout="auto" unmountOnExit>
      <List
        component="div"
        disablePadding
        sx={{
          mb: '5px',
        }}
      >
        {menuOptions.map((option) => (
          <SubMenuItem
            key={option.key}
            label={option.label}
            onClick={() => {
              if (onSubItemClick) {
                onSubItemClick(option);
              }
            }}
            active={option.link ? isMenuOptionActive(option.link) : false}
          />
        ))}
      </List>
    </Collapse>
  );
};
